import { useEffect, useState } from "react";
import FileUploader from "../../../components/FileUploader";

const MadrasaPostVideoProofs = ({translation, postVideos, setCurrentStep, postSlug, isUpdate}) => {

  const [uploadedPlaceVideo, setUploadedPlaceVideo] = useState(false);
  const [uploadedCommitteeMemberVideo, setUploadedCommitteeMemberVideo] = useState(false);

  const [oldCommitteeMemberVideo, setOldCommitteeMemberVideo] = useState(null)
  const [oldPlaceVideo, setOldPlaceVideo] = useState(null)
  
  useEffect(()=>{
    if (postVideos){
      setOldCommitteeMemberVideo(postVideos?.videos?.committee_member_video)
      setOldPlaceVideo(postVideos?.videos?.place_video)
      setUploadedPlaceVideo(true)
      setUploadedCommitteeMemberVideo(true)
    }
  }, [postVideos])
  

  return (
    <>
      <div className="pt-2 pb-5 space-y-4">
        <div className="flex flex-col space-y-1">
          <label htmlFor="committee_member_video" className="block font-semibold mb-2 dark:text-white">{translation.other.committee_member_video}</label>
          
          <FileUploader
            key="committee_member_video_uploader"
            fileNameInDB={'committee_member_video'}
            allowedTypes={['mp4', 'mpeg', 'mp4', 'avi', 'mov']}
            onSuccess={(filePath)=>{
              setUploadedCommitteeMemberVideo(true);
              setOldCommitteeMemberVideo(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-video-path/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={500}
             
            awsUploadDestination={'posts/username/videos/seeker'}
            description={translation.other.madrasa_committee_member_video_dep}
            showPreview={oldCommitteeMemberVideo ? `${process.env.REACT_APP_CDN_URL}/${oldCommitteeMemberVideo}` : null} 
            
          />
        </div>

      </div>

      <div className="pt-2 pb-5 space-y-4">
        <div className="flex flex-col space-y-1">
          <label htmlFor="place_video" className="block font-semibold mb-2 dark:text-white">{translation.other.madrasa_video}</label>
          
          <FileUploader
            key="place_video_uploader"
            fileNameInDB={'place_video'}
            allowedTypes={['mp4', 'mpeg', 'mp4', 'avi', 'mov']}
            onSuccess={(filePath)=>{
              setUploadedPlaceVideo(true)
              setOldPlaceVideo(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-video-path/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={500}
             
            awsUploadDestination={'posts/username/videos/place'}
            description={translation.other.madrasa_video_description}
            showPreview={oldPlaceVideo ? `${process.env.REACT_APP_CDN_URL}/${oldPlaceVideo}` : null} 
            
          />

        </div>

      </div>

      <div className="flex space-x-3">
        {isUpdate && 
          <button
            onClick={()=>{
              setCurrentStep("create_bank_details");
            }}
            className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
          >
            {translation.back}
          </button>
        }
        
        <button
          type="button"
          onClick={() => {setCurrentStep("attach_doc_proofs");}}
          className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
          disabled={!uploadedCommitteeMemberVideo & !uploadedPlaceVideo}
        >
          {translation.next}
        </button>
      </div>
    </>
  )
}

export default MadrasaPostVideoProofs;